$(document).ready(function () {
  if ($("div.bgVideo").length) {
    console.log("UPDATED");
    $("#shopify-section-header-classic").addClass("enableOverlayHeader");
    // console.log("UPDATEDSURE");
  }

  var navigationSlider = new Swiper(".megaMenuSlider", {
    spaceBetween: 30,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 1,
        loop: true,
      },
      768: {
        slidesPerView: 4,
        loop: true,
      },
      1024: {
        slidesPerView: 4,
        loop: true,
      },
    },
  });
  var customLinkImages = new Swiper(".mySwiperCustomLinkImages", {
    slidesPerView: 2.5,
    spaceBetween: 10,
    loop: true,
    initialSlide: 2,
    pagination: {
      el: ".imageFeedPaginations",
      clickable: true,
    },
    navigation: {
      nextEl: ".nxtImgBtn",
      prevEl: ".prevImgBtn",
    },
    breakpoints: {
      640: {
        slidesPerView: 2.5,
        spaceBetween: 30,
        loop: true,
        freeMode: true,
        initialSlide: 2,
      },
      768: {
        slidesPerView: 3,
        loop: true,
        initialSlide: 0,
      },
      1024: {
        slidesPerView: 3,
        loop: true,
        initialSlide: 0,
      },
    },
  });

  var customGridViewImages = new Swiper(".customGridViewImages", {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    loop: true,
    pagination: {
      el: ".gridAreaPagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".nxtGridBtn",
      prevEl: ".prevGridBtn",
    },
  });

  // custom video block section code start

  $(".videoPlayBtn").click(function () {
    // console.log("played");

    $(this).parent().addClass("hideVideOverlay");
    $(this).parent().next().next("video").trigger("play");

    // $('video').trigger('pause');
  });

  $(".videoPauseBtn").click(function () {
    // console.log("played");

    $(this).prev(".vidThumbnail").removeClass("hideVideOverlay");
    $(this).next("video").trigger("pause");
  });

  // custom video block section code end

  // how to page carousel

  var howToCarousel = new Swiper(".howToCarousel", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    speed: 1000,
    loop: true,
    pagination: {
      el: ".howToPagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".howToNxt",
      prevEl: ".howToPrev",
    },
  });

  // home page Sections Slider Which are linked with Hero Slider code start
  var slideShowSpeed = $(".heroMainSlide").attr("data-slideShowSpeed");
  var sliderAutoPlay = $(".heroMainSlide").attr("data-autoplay");
  var autoPlayMS = parseInt(slideShowSpeed);
  var isTrueAutoplay = sliderAutoPlay === "true";
  // console.log(isTrueAutoplay);
  if (isTrueAutoplay) {
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      speed: 500,
      loop: false,
      autoplay: {
        delay: autoPlayMS,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  } else {
    var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      speed: 500,
      loop: false,
      autoplay: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
  // stop autoplay after 300px scroll code start
  $(window).scroll(function () {
    if ($(document).scrollTop() > 300) {
      // console.log(isTrueAutoplay + "makeFalse");
      swiper.autoplay.stop();
    } else {
      // console.log(isTrueAutoplay + "makeTrue");
      if (isTrueAutoplay) {
        swiper.autoplay.start();
      } else {
        swiper.autoplay.stop();
      }
    }
  });

  var clicks = 0;
  $(".prevSwipe").click(function () {
    swiper.slidePrev();
    let totalSlides = swiper.slides.length;
    let currentSlide = swiper.activeIndex + 1;
    if (currentSlide == 1) {
      if (clicks == 0) {
        clicks = 1;
      } else {
        clicks = 0;
        swiper.slideTo(totalSlides);
      }
    }
  });

  $(".nxtSwipe").click(function () {
    swiper.slideNext();
    let totalSlides = swiper.slides.length;
    let currentSlide = swiper.activeIndex + 1;
    if (currentSlide == totalSlides) {
      if (clicks == 0) {
        clicks = 1;
      } else {
        clicks = 0;
        swiper.slideTo(0);
      }
    }
  });
  // stop autoplay after 300px scroll code end

  var swiper2 = new Swiper(".mySwiper2", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    speed: 500,
    loop: false,
  });
var swiper3 = new Swiper(".mySwiper3", {
    slidesPerView: 1,
    spaceBetween: 30,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    speed: 500,
    loop: false,
    pagination: {
      el: ".prodGalPagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper3Nxt",
      prevEl: ".swiper3Prev",
    },
});
  var swiper4 = new Swiper(".mySwiper4", {
    slidesPerView: 1,
    spaceBetween: 0,
    effect: "fade",
    speed: 500,
    loop: false,
    pagination: {
      el: ".ftCollectionPagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".collectionNxtBtn",
      prevEl: ".collectionPrevBtn",
    },
  });
  swiper.on("slideChange", function (e) {
    swiper2.slideTo(swiper.activeIndex);
    swiper3.slideTo(swiper.activeIndex);
    swiper4.slideTo(swiper.activeIndex);

    var currentUrl = $(".swiper-slide-active .mainHeroImgContainer").attr(
      "data-url"
    );

    $(".heroBtn").attr("href", currentUrl);
  });
  swiper2.on("slideChange", function (e) {
    swiper.slideTo(swiper2.activeIndex);
    swiper3.slideTo(swiper2.activeIndex);
    swiper4.slideTo(swiper2.activeIndex);
  });
  swiper3.on("slideChange", function (e) {
    swiper.slideTo(swiper3.activeIndex);
    swiper2.slideTo(swiper3.activeIndex);
    swiper4.slideTo(swiper3.activeIndex);
  });
  swiper4.on("slideChange", function (e) {
    swiper.slideTo(swiper4.activeIndex);
    swiper2.slideTo(swiper4.activeIndex);
    swiper3.slideTo(swiper4.activeIndex);
    var wrapperColor = $(
      ".customCollectionLinkedSlider .swiper-slide-active .product-wrap"
    ).attr("data-color");
    $(".collectionPrevBtn").css("color", wrapperColor);
    $(".collectionNxtBtn").css("color", wrapperColor);
  });
  swiper.on("reachEnd", function () {
    $(".nxtSwipe").addClass("disabledNxtBtn");
  });
  var defaultCollectionBtn = $(
    ".customCollectionLinkedSlider .swiper-slide-active .product-wrap"
  ).attr("data-color");
  $(".collectionPrevBtn").css("color", defaultCollectionBtn);
  $(".collectionNxtBtn").css("color", defaultCollectionBtn);
  // home page Sections Slider Which are linked with Hero Slider code end

  $(".purchase-details__quantity span.quantity-plus").click(function () {
    setTimeout(function () {
      var prodQty = $(".purchase-details__quantity input.quantity-input").val();
      // console.log("myquant" + prodQty);
      $("#prodQTYLabel").text(prodQty);
    }, 1500);
  });
  $(".purchase-details__quantity span.quantity-minus").click(function () {
    setTimeout(function () {
      var prodQty = $(".purchase-details__quantity input.quantity-input").val();
      // console.log("myquant" + prodQty);
      $("#prodQTYLabel").text(prodQty);
    }, 1500);
  });

  //  hero section view more view less code start
  $("#heroViewMoreBtn").click(function () {
    $(this).hide();
    // $(".heroBtns").hide();
    $(this).parent(".heroSubTxt").addClass("activeAllTxt");
    $(".viewMoreTxt").show();
    // $(".viewLessHeroBtn").show();
    $("#heroViewLessBtn").show();
    $(".stickyTxtContent .caption").addClass("liftUp");
    $(".heroMainSlide").addClass("expandSec");
  });

  $("#heroViewLessBtn").click(function () {
    $(this).hide();
    // $(".heroBtns").show();
    $(this).parent(".heroSubTxt").removeClass("activeAllTxt");
    $(".viewMoreTxt").hide();
    // $(".viewLessHeroBtn").hide();
    $("#heroViewMoreBtn").show();
    $(".heroMainSlide").removeClass("expandSec");
  });

  //  hero section view more view less code end

  // product page swatches name change on hover

  $(".swatch__option").on("mouseover", function () {
    var labelToShow = $(this).attr("data-id");
    $(this)
      .parent(".swatch__options")
      .prev(".option-title")
      .children(".options-selection__option-name")
      .children("span")
      .children(".originalStyleName")
      .hide();
    $(labelToShow).show();
  });

  $(".purchase-details").on("mouseover", function () {
    $(".originalStyleName").hide();
    $(".defaultActive").show();
  });

  // mobile menu drawer opener
  $(".mobile-menu__toggle-icon").click(function () {
    console.log("add");
    $("#mobile-header").toggleClass("openSideMenu");
  });

  // custom newsletterPopupOpener

  $(".newsLetterPopupOpener").click(function () {
    $("#customNewsLetterPopup").addClass("OpenPopup");
  });
  $("#customPopupCloseBtn, .popupOverlayContainer").click(function () {
    $("#customNewsLetterPopup").removeClass("OpenPopup");
  });

  setInterval(function () {
    if ($(".rebuy-cart")[0]) {
      $(".disabledCart").removeClass("disabledCart");
      console.log("found");
    }
  }, 500);
});
// ticket tape scroll animation code start
// $(document).on('scroll', function(){
//    $('.animateOnScroll img').css("left", 20) + "vw");
//  });

var objVal = 10;
var lastScrollTop = 0;
$(function () {
  $(window).scroll(function (event) {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
      if ($(window).width() < 960) {
        objVal = objVal - 50;
      } else {
        objVal = objVal - 10;
      }

      elementPosition = objVal.toString() + "px";
      //   var scroll_position = $(window).scrollTop();
      //   var object_position_left = window_width * (scroll_position / document_height);
      $(".animateOnScroll .animateItem").css({
        left: elementPosition,
      });
      // console.log(objVal);
    } else {
      if ($(window).width() < 960) {
        objVal = objVal + 50;
      } else {
        objVal = objVal + 10;
      }
      elementPosition = objVal.toString() + "px";
      //   var scroll_position = $(window).scrollTop();
      //   var object_position_left = window_width * (scroll_position / document_height);
      $(".animateOnScroll .animateItem").css({
        left: elementPosition,
      });
      // console.log(objVal);
    }
    lastScrollTop = st;
  });
});

// ticker tape scroll animation code end

// some extra functionality for product page parallax bg and video code start

  if ($(window).width() < 991) {
    var allNextHtml = $("div#template-product").html();
    var allNextChild = $("div#template-product .dynamic-sections")
      .children()
      .not(".shopify-section.product-template");
    allNextChild.remove();
    $("#elementsContainer").html(allNextHtml);
    $("#elementsContainer .shopify-section.product-template").remove();
  }
$(window)
  .on("scroll", () => {
    $("#elementsContainer").each(function () {
      var offset = $(this).offset().top - $(window).scrollTop();
      if (offset <= 6) {
        $(this).addClass("makeParallax");
      } else {
        $(this).removeClass("makeParallax");
      }
    });
  })
  .trigger("scroll");
// some extra functionality for product page parallax bg and video code end


//  const showAnim = gsap.from('.header-wrapper', { 
//   yPercent: -100,
//   paused: true,
//   duration: 0.2
// }).progress(1);

// ScrollTrigger.create({
//   start: "top top",
//   end: 99999,
//   onUpdate: (self) => {
//     self.direction === -1 ? showAnim.play() : showAnim.reverse()
//   }
// });

// ScrollTrigger.create({
//   trigger: "body",
//   start: "top top",
//   end: "+=10",
//   onEnter: () => gsap.to(".header-wrapper", { height: 70, duration: 0.2 }),
//   onLeaveBack: () => gsap.to(".header-wrapper", { height: 111, duration: 0.2 }),
//   markers: false,
// });

